import { Box, Button, MenuItem, Select } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import UserTab from '../../components/UserTab'
import SearchBar from '../../components/SearchBar'
import Loader from '../../components/Loader';
import * as api from '../services/api'


const styles = {
    green: {
        backgroundColor: "#C8EBEB",
        border: '1px solid transparent',
        color: '#252641',
        padding: 2,
        fontSize: 14,
        fontWeight: 600,
        width: 200,
        borderTopLeftRadius: '6px',
        borderTopRightRadius: '6px',
        cursor: 'pointer'
    },
    white: {
        backgroundColor: "transparent",
        border: '1px solid #AEB4DD',
        color: '#478F96',
        padding: 2,
        fontSize: 14,
        fontWeight: 600,
        width: 200,
        borderTopLeftRadius: '6px',
        borderTopRightRadius: '6px',
        cursor: 'pointer'
    }
}


function ManageUsers() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [searchQuery, setSearchQuery] = useState('');
    const [activeTab, setActiveTab] = useState('Active User');
    const [filteredData, setFilteredData] = useState([]);
    const [page, setPage] = useState(1);

    const [usertype, setUsertype] = useState('')
    const [usertypeList, setUsertypeList] = useState([])

    useEffect(() => {
        fetchUserData(1, null);
        findUserGroup()
    }, []);

    // useEffect(() => {

    //     setActiveUsers(data[activeTab])
    // }, [])

    const fetchUserData = async (page, search) => {
        setLoading(true);
        let status = "N"
        if (activeTab === 'Active User') {
            status = "W"
        } else if (activeTab === 'UnActive User') {
            status = "C"
        }
        // const res = await api.findUser(page, search, status)
        const res = await api.findUserbyType(page, search, status, usertype)
        setLoading(false);
        if (res) {
            if (res['data']['code'] === 200) {
                const detail = res['data']['data'];
                setFilteredData(detail);
                // setTotalPage(res['data']['pagging']['totalPage'])
            } else if ("Not found data." === res['data']['message']) {
                setFilteredData([]);
                // setTotalPage(1);
            } else {
                //alert(res['data']['message']);
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    };

    const handleSearch = (searchQuery) => {
        fetchUserData(1, searchQuery, activeTab)
        // setFilteredData(result);
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        // setFilteredData(data[tab]);
        setPage(1)
        fetchUserData(1, null, tab)
        setSearchQuery('');
    };

    const findUserGroup = async () => {
        setLoading(true)
        let res = await api.findUserGroup()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                // console.log(res['data']['data'])
                setUsertypeList(res['data']['data'])
            } else {
                alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }


    return (
        <>
            <Loader loading={loading} />
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{ color: '#478F96', fontWeight: 600 }}>จัดการผู้ใช้งานระบบ</Box>
                <Box sx={{ fontSize: 14 }}>อนุมัติ แก้ไข หรือปิดบัญชีผู้ใช้งาน</Box>
                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    padding: '20px',
                    gridGap: '20px'
                }}>
                    <Box sx={{ fontWeight: 600 }}>ค้นหาผู้ใช้งาน</Box>
                    <SearchBar
                        label="ค้นหาด้วยชื่อ/ เลขบัตรประชาชน"
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        handleSearch={handleSearch}
                    />

                    {activeTab !== 'Permission' ?
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '10px', gap: '10px' }}>
                            <Select
                                size='small'
                                sx={{ ...SelectCss }}
                                value={usertype || "null"}
                                onChange={(e) => {
                                    setUsertype(e.target.value)
                                    fetchUserData(1, searchQuery, activeTab, e.target.value)
                                }}
                            >
                                <MenuItem value="null">
                                    เลือกประเภทผู้ใช้งาน
                                </MenuItem>
                                {usertypeList.map((i, idx) => (
                                    <MenuItem key={idx} value={i['group_code']}>{i['group_name']}</MenuItem>
                                ))}
                            </Select>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => navigate('/addUser')}
                            >
                                <p style={{ fontWeight: 600, margin: 0, padding: '0 35px' }}>เพิ่มผู้ใช้งาน</p>
                            </Button>
                        </Box>
                        :
                        <Box margin={8}></Box>
                    }
                    {/* Tab headers */}
                    <div className="tabs" style={{ display: "flex" }}>
                        <Box
                            align="center"
                            sx={activeTab === 'Active User' ? styles.green : styles.white}
                            onClick={() => handleTabChange('Active User')} className={activeTab === 'Active User' ? 'active' : ''}>
                            บัญชีที่ใช้งานอยู่
                        </Box>
                        <Box
                            align="center"
                            sx={activeTab === 'New User' ? styles.green : styles.white}
                            onClick={() => handleTabChange('New User')} className={activeTab === 'New User' ? 'active' : ''}>
                            บัญชีที่รอการอนุมัติ
                        </Box>
                        <Box
                            align="center"
                            sx={activeTab === 'UnActive User' ? styles.green : styles.white}
                            onClick={() => handleTabChange('UnActive User')} className={activeTab === 'UnActive User' ? 'active' : ''}>
                            บัญชีที่ปิดใช้งานไปแล้ว
                        </Box>
                        <Box
                            align="center"
                            sx={activeTab === 'Permission' ? styles.green : styles.white}
                            onClick={() => handleTabChange('Permission')} className={activeTab === 'Permission' ? 'active' : ''}>
                            จัดการสิทธิ
                        </Box>
                    </div>
                    <UserTab users={filteredData} activeTab={activeTab} currentPage={page} searchQuery={searchQuery} userTypeRole={usertype} />
                </Box>
            </Box>
        </>
    )
}

export default ManageUsers

const SelectCss = {
    backgroundColor: '#C8EBEB',
    border: 'none',
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
}